/**
 * IDs = 32-bit integers.
 * Lowest 24 bits are the ID itself.
 * Highest 8 bits are the version.
 * An ID with an incremented version is the same ID (same index),
 * but indicates that the resource referred to by an older version
 * is no longer existent.
 */
export var VERSION_MASK = 4278190080;
export var SIGNIFIER_MASK = 16777215;
/**
 * Gets only the portion of the ID that signifes the
 * resource it represents.
 */
export function getIdSignifier(id) {
    // mask out high 8 bits
    return SIGNIFIER_MASK & id;
}
/**
 * Gets only the version portion of the ID
 */
export function getIdVersion(id) {
    return id >>> 24;
}
export function setIdVersion(id, version) {
    version = version % 255 << 24;
    return id | version;
}
export function incrementIdVersion(id) {
    return setIdVersion(id, getIdVersion(id) + 1);
}
//# sourceMappingURL=ids.js.map